import { Box } from '@mui/system';
import { XSymbol } from '../../styled-components/FormStyledComponents';

const CloseButton = (props: { onHide: () => void }) => {
  return (
    <XSymbol
      className="close-button"
      onClick={() => {
        props.onHide();
      }}
      sx={{ border: '2px solid black', cursor: 'pointer' }}
      tabIndex={0}
    >
      <Box sx={{ top: '-6px !important' }}>+</Box>
    </XSymbol>
  );
};

export default CloseButton;
